import { massageGoogleDriveURL } from "common/components/portable-renderers";
import * as React from "react";
import { Player, Wrapper } from "./video-player-view-style";

interface Props {
    readonly url: string;
    readonly shouldPlay: boolean;

    readonly className?: string;
}

class VideoPlayerImpl extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { className, shouldPlay, url } = this.props;
        return (
            <Wrapper data-test="app-video-player" className={className + ` fullBleed`}>
                <Player
                    playing={shouldPlay ? undefined : false}
                    width="100%"
                    height="100%"
                    controls={true}
                    url={massageGoogleDriveURL(url)}
                    config={{
                        youtube: {
                            embedOptions: { rel: 0 },
                        },
                    }}
                />
            </Wrapper>
        );
    }
}

const VideoPlayerView = VideoPlayerImpl;
export default VideoPlayerView;
